import { DefaultButton, IColumn, mergeStyleSets, ShimmeredDetailsList, Stack, Text } from '@fluentui/react';
import { Component } from 'react';

export default class RevenuePage extends Component {
  private columns: IColumn[] = [];

  render() {
    return (
      <div className={styles.container}>
        <Stack horizontal>
          <Text variant="xLarge">Ciro</Text>
          <Stack
            grow
            horizontal
            horizontalAlign="end"
            tokens={{ childrenGap: 10 }}
          >
            <DefaultButton text="test" />
            <DefaultButton text="test" />
          </Stack>
        </Stack>
        <ShimmeredDetailsList items={[]} columns={this.columns} />
      </div>
    );
  }
}

const styles = mergeStyleSets({
  container: {
    width: "90%",
    marginLeft: "5%",
    marginTop: "12px",
  },
});
